// src/Pages/Purchase/PurchaseOrders.jsx
import React, { useState } from "react";
import { usePurchaseOrders } from "../../context/PurchaseOrdersContext";
import { Link, useNavigate } from "react-router-dom";
import "./PurchaseOrders.css";

const PurchaseOrders = () => {
  const { purchaseOrders } = usePurchaseOrders();
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const filteredPurchaseOrders = purchaseOrders.filter(
    (po) =>
      po.poNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      po.vendorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      po.referenceNo?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStatusClass = (status) => {
    switch ((status || "").toUpperCase()) {
      case "PAID":
        return "status-paid";
      case "SENT":
        return "status-sent";
      case "OVERDUE":
        return "status-overdue";
      case "DRAFT":
      default:
        return "status-draft";
    }
  };

  const handleRowClick = (poId) => {
    navigate(`/purchase/purchase-orders/view/${poId}`);
  };

  const formatCurrency = (amount) => {
    return (
      "₹" +
      Number(amount || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  };

  const formatDate = (date) => {
    try {
      return new Date(date).toLocaleDateString("en-IN");
    } catch {
      return "—";
    }
  };

  return (
    <div className="po-wrapper">
      <div className="po-container">
        {/* Header */}
        <div className="po-header">
          <h1>All Purchase Orders</h1>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Search by PO#, Vendor or Reference..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/purchase/purchase-orders/new">
              <button className="new-po-btn">+ New Purchase Order</button>
            </Link>
          </div>
        </div>

        {/* Empty State */}
        {filteredPurchaseOrders.length === 0 && (
          <div className="state-card empty">
            <h3>
              {searchTerm
                ? `No purchase orders found for "${searchTerm}"`
                : "No Purchase Orders Yet"}
            </h3>
            <p>Create your first purchase order to get started.</p>
            <Link to="/purchase/purchase-orders/new">
              <button className="new-po-btn">+ Create First PO</button>
            </Link>
          </div>
        )}

        {/* List */}
        {filteredPurchaseOrders.length > 0 && (
          <div className="po-list">
            {/* Desktop Header */}
            <div className="table-header4">
              <span></span>
              <span>DATE</span>
              <span>PO#</span>
              <span>REFERENCE#</span>
              <span>VENDOR</span>
              <span>STATUS</span>
              <span>DELIVERY DATE</span>
              <span>AMOUNT</span>
              <span>BALANCE DUE</span>
            </div>

            {/* Rows */}
            {filteredPurchaseOrders.map((po) => (
              <div
                key={po._id}
                className="po-row"
                onClick={() => handleRowClick(po._id)}
              >
                <input type="checkbox" onClick={(e) => e.stopPropagation()} />

                <span data-label="Date">{formatDate(po.date)}</span>

                <span data-label="PO#" className="po-no">
                  {po.poNo}
                </span>

                <span data-label="Reference#">{po.referenceNo || "—"}</span>

                <span data-label="Vendor" className="vendor-name">
                  {po.vendorName || "Unknown Vendor"}
                </span>

                <span
                  data-label="Status"
                  className={`status-badge ${getStatusClass(po.status)}`}
                >
                  {po.status || "Draft"}
                </span>

                <span data-label="Delivery Date">
                  {po.deliveryDate ? formatDate(po.deliveryDate) : "—"}
                </span>

                <span data-label="Amount" className="amount">
                  {formatCurrency(po.amount || po.total)}
                </span>

                <span data-label="Balance Due" className="balance-due">
                  {formatCurrency(po.balanceDue || po.total || 0)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseOrders;
